import { TextField } from '@doordash/component-fields'
import Toggle from '@doordash/component-toggle'
import { get } from 'lodash'
import * as React from 'react'
import { BGC_UPDATE_FORM_VALIDATION } from '../../../../experimentConstants'
import { ProfileSetup as Tag } from '../../../../models/selectorAnchors'
import t from '../strings'

type Props = {
  fields: { [k: string]: string }
  handleChange: (name, value) => void
  middleNameInputDisabled: boolean
  toggleMiddleName: () => void
  experiments?: object
}

export class DefaultNamesEntryForm extends React.Component<Props> {
  public static defaultProps = {
    fields: {
      firstName: '',
      lastName: '',
      middleName: '',
    },
    handleChange: (name, value) => {},
    middleNameInputDisabled: false,
    toggleMiddleName: () => {},
  }

  public render() {
    const { middleNameInputDisabled, toggleMiddleName } = this.props
    return (
      <React.Fragment>
        <TextField
          label={
            this.isBGCFormExperimentOn() ? t.legalFirstName() : t.firstName()
          }
          onChange={value => this.props.handleChange('firstName', value)}
          autoComplete="given-name"
          description={t.required()}
          data-anchor-id={Tag.FirstName}
          {...this.props.fields.firstName}
        />
        <TextField
          disabled={middleNameInputDisabled}
          label={
            this.isBGCFormExperimentOn() ? t.legalMiddleName() : t.middleName()
          }
          onChange={value => this.props.handleChange('middleName', value)}
          autoComplete="additional-name"
          description={!middleNameInputDisabled && t.required()}
          data-anchor-id={Tag.MiddleName}
          {...this.props.fields.middleName}
        />
        <div data-anchor-id={Tag.NoMiddleNameToggle}>
          <Toggle
            alignToggle={Toggle.Alignment.Center}
            type={Toggle.Types.Checkbox}
            onChange={() => toggleMiddleName()}
            isSelected={middleNameInputDisabled}
            label={t.noMiddleNameLabel()}
          />
        </div>
        <TextField
          label={
            this.isBGCFormExperimentOn() ? t.legalLastName() : t.lastName()
          }
          onChange={value => this.props.handleChange('lastName', value)}
          autoComplete="family-name"
          description={t.required()}
          data-anchor-id={Tag.LastName}
          {...this.props.fields.lastName}
        />
      </React.Fragment>
    )
  }

  private isBGCFormExperimentOn = (): boolean => {
    const { experiments } = this.props
    return get(experiments, `${BGC_UPDATE_FORM_VALIDATION}`, false)
  }
}
